<template>
  <div>
    <form-field-editor
      label="Statement"
      v-model="form.statement"
      :is-tall="true"
      :validation-errors="validationErrors.statement"
    ></form-field-editor>

    <b-field label="Search Field">
      <b-autocomplete
        v-model="searchField"
        :data="filterStepsFields"
        field="displayLabel"
        :open-on-focus="true"
        :clear-on-select="true"
        placeholder="e.g. Property - Full Address"
        icon="magnify"
        keep-first
        @select="selectedField($event)"
      >
        <template #empty>No results for {{ searchField }}</template>
      </b-autocomplete>
    </b-field>

    <table-draggable
      :class="{'space-bottom': form.fields.length <= 2}"
      :table-data="form.fields"
    >
      <b-table-column label="No." width="70" v-slot="props">
        <icon-default
          icon="sort"
          size="is-small"
          color="is-link"
        ></icon-default>
        {{ props.index + 1 }}.
      </b-table-column>

      <b-table-column label="Fields" field="displayLabel" v-slot="props">
        {{ props.row.displayLabel }}
      </b-table-column>

      <b-table-column label="" cell-class="action_cell" width="100" v-slot="props">
        <b-switch
          v-model="props.row.required"
          size="is-small"
          expanded
          :true-value="1"
          :false-value="0"
        >Required</b-switch>
      </b-table-column>

      <b-table-column cell-class="action_cell" width="100" v-slot="props">
        <button @click="remove(props)" class="remove-btn delete"></button>
      </b-table-column>
    </table-draggable>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "CallScriptStepForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        call_script_id: '',
        statement: '',
        fields: [],
      },
      searchField: ''
    }
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone({...this.defaultForm, ...this.formData}) : this.$utils.clone(this.defaultForm);
  },
  computed: {
    filterStepsFields() {
      return this.unusedStepFields.filter((option) => {
        return option.displayLabel
          .toString()
          .toLowerCase()
          .indexOf(this.searchField.toLowerCase()) >= 0
      });
    },
    unusedStepFields() {
      const usedFields = this.formData.step_fields;
      const maps = this.$utils.clone(this.formData.step_fields_data);

      for (let i = 0; i < usedFields.length; i++) {
        for (let j = 0; j < maps.length; j++) {
          if (usedFields[i].displayLabel === maps[j].displayLabel) {
            maps.splice(j, 1);
            j--;
          }
        }
      }

      return maps;
    },
  },
  methods: {
    selectedField(field) {
      if (field) {
        // push to field list
        this.form.fields.push(field);
        // push to global field list
        this.formData.step_fields.push(field);
      }
    },
    update() {
      return this.$api.callScriptSteps.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Call script step was updated',
            type: 'is-success'
          });

          return res;
        });
    },
    create() {
      return this.$api.callScriptSteps.create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Call script step was created',
            type: 'is-success'
          });

          return res;
        });
    },
    delete() {
      return this.$api.callScriptSteps.delete(this.form.id)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Call script step was deleted',
            type: 'is-success'
          });

          return res;
        });
    },
    remove(field) {
      // remove from the field list
      this.form.fields.splice(field.index, 1);
      // find index and remove from the global step field list
      const stepFieldIndex = this.formData.step_fields.findIndex(stepField => stepField.displayLabel === field.row.displayLabel)
      this.formData.step_fields.splice(stepFieldIndex, 1);
    },
  },
}
</script>

<style lang="scss" scoped>
.space-bottom {
  margin-bottom: 7rem;
}
</style>
